import { render, staticRenderFns } from "./outerStock.vue?vue&type=template&id=18714b2d&scoped=true&"
import script from "./outerStock.vue?vue&type=script&lang=js&"
export * from "./outerStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18714b2d",
  null
  
)

export default component.exports